var map = {
	"./conference.webp": 595,
	"./dod.webp": 728,
	"./dummy-image.webp": 687,
	"./github.webp": 142,
	"./humanrace.webp": 407,
	"./internsconnected.webp": 733,
	"./kidchess.webp": 797,
	"./lecture.webp": 117,
	"./linkedin.webp": 727,
	"./nasaspaceapps.webp": 294,
	"./redandblack.webp": 700,
	"./research.webp": 828,
	"./resume.webp": 62,
	"./train.webp": 581,
	"./ugascs.webp": 963
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 379;